import { API } from 'aws-amplify';

import { listExpenseSearch } from '../../../../graphql/customQueries';
import { getExpense, listExpenseSearchOptions, listHotels, listStates } from '../../../../graphql/queries';

// CP-813: driver/customer Search criteria sourced from expense records (incl. termed drivers) instead of
// the active-only EDGE lists. Cached per-lob for 5 minutes, mirroring the EDGE list cache in operations.js.
const SEARCH_OPTIONS_CACHE_TTL = 5 * 60 * 1000; // 5 minutes
const searchOptionsCache = new Map();

export const getExpenseSearchOptions = async lob => {
  const key = lob ?? 'MDS';
  const now = Date.now();
  const cached = searchOptionsCache.get(key);
  if (cached && now - cached.time < SEARCH_OPTIONS_CACHE_TTL) {
    return cached.data;
  }

  try {
    const response = await API.graphql({
      query: listExpenseSearchOptions,
      variables: { lob },
    });
    const data = response?.data?.listExpenseSearchOptions ?? { drivers: [], customers: [], assignments: [] };
    searchOptionsCache.set(key, { data, time: now });
    return data;
  } catch (e) {
    console.log(e);
    return undefined;
  }
};

export const getExpensesFiltered = async (filters, lastEvaluatedKey) => {
  try {
    const response = await API.graphql({
      query: listExpenseSearch,
      variables: {
        assignmentId: filters.assignmentId,
        branch: filters.branch,
        code: filters.code,
        costCenter: filters.costCenter,
        customerId: filters.customerId,
        documentName: filters.documentName,
        driverId: filters.driverId,
        driverName: filters.driverName,
        createdAt: filters.createdAt,
        endDate: filters.endDate,
        expenseItemAirLineId: filters.expenseItemAirLineId,
        expenseItemCarRentalCompanyId: filters.expenseItemCarRentalCompanyId,
        expenseItemHotelCityId: filters.expenseItemHotelCityId,
        expenseItemHotelId: filters.expenseItemHotelId,
        expenseItemHotelStateId: filters.expenseItemHotelStateId,
        notes: filters.notes,
        payWeekEnding: filters.payWeekEnding,
        status: filters.status,
        limit: 1000,
        lob: filters.lob,
        creditCardHolderName: filters.creditCardHolderName,
        statementDate: filters.statementDate,
        expenseReportAppropriationNbr: filters.expenseReportAppropriationNbr,
        lastEvaluatedKey: lastEvaluatedKey,
      },
    });

    return response?.data?.listExpenseSearch;
  } catch (e) {
    // CP-859: this used to swallow the error and return undefined. formatExpenses(undefined)
    // returns [], so a failed or timed-out page was indistinguishable from "0 results" - the
    // search drain would stop, sort whatever it had, clear the spinner, and present a partial
    // result set as a completed search. Let the caller decide what to show.
    console.log(e);
    throw e;
  }
};

export const getExpenseById = async id => {
  try {
    const response = await API.graphql({
      query: getExpense,
      variables: {
        id: id,
      },
    });
    return response.data.getExpense;
  } catch (e) {
    console.log(e);
    return undefined;
  }
};

export const getHotels = async () => {
  try {
    const response = await API.graphql({
      query: listHotels,
      variables: {
        limit: 10000,
      },
    });
    return response?.data?.listHotels?.items;
  } catch (e) {
    console.log(e);
    return undefined;
  }
};

export const getStates = async () => {
  try {
    const response = await API.graphql({
      query: listStates,
      variables: {
        limit: 10000,
      },
    });

    return response.data?.listStates?.items?.length ? response.data?.listStates?.items : [];
  } catch (e) {
    console.log(e);
  }
  return undefined;
};
